/**
 * Centralized error messages for the error modal
 * Maps error types to their corresponding user-facing messages
 */
export const errorMessages = {
  general_error:
    'Sorry for the inconvenience. Please try again later. If the problem persists, contact support.',

  // Post-related errors
  post_regeneration_error:
    'Sorry for the inconvenience. The post regeneration failed. Please try again later. If the problem persists, please contact support.',
  regeneration_rate_limit_error:
    'Sorry for the inconvenience. You have reached the regeneration limit.  If you need more regenerations, please consider upgrading your subscription. If you have already upgraded or have more questions, please contact support.',
  post_update_error:
    'Sorry for the inconvenience. The post update failed. Please try again later. If the problem persists, please contact support.',
  post_schedule_error:
    'Sorry for the inconvenience. The post scheduling failed. Please try again later. If the problem persists, please contact support.',
  post_edit_error:
    'Sorry for the inconvenience. Failed to edit post. Please try again later. If the problem persists, contact support.',
  post_poll_server_error:
    'Sorry for the inconvenience. We encountered a server error while updating your post. Please try again later. If the problem persists, contact support.',
  dashboard_posts_timeout:
    'Sorry for the inconvenience. Loading your posts is taking longer than expected. Please try refreshing the page or contact support if the problem persists.',

  // Profile-related errors
  profile_check_error:
    "Sorry for the inconvenience, but there was an issue creating your profile. This is likely due the website is not found or doesn't exists. Please check the website URL you provided and try again with another URL. If the problem persists, contact support.",
  profile_creation_failed:
    "Sorry for the inconvenience, but there was an issue with creating you profile. This is likely due the website is not found or doesn't exists. Please check the website URL you provided and try again with another URL. if the problem persists, contact support.",
  profile_analysis_error:
    'Sorry for the inconvenience. An error occurred while analyzing the website. Please try again later. If the problem persists, contact support.',
  update_profile_summary_error:
    'Sorry for the inconvenience, but there was an issue updating your profile summary. Please try again later. If the problem persists, contact support.',

  // Offering-related errors
  update_offering_error:
    'Sorry for the inconvenience, but there was an issue updating your offering. Please try again later. If the problem persists, contact support.',
  add_offering_error:
    'Sorry for the inconvenience, but there was an issue adding your offering. Please try again later. If the problem persists, contact support.',
  delete_offering_error:
    'Sorry for the inconvenience, but there was an issue deleting your offering. Please try again later. If the problem persists, contact support.',

  // Social account errors
  social_connect_error:
    'Sorry for the inconvenience. We encountered an issue while connecting your social account. Please try again later. If the problem persists, contact support.',
  social_disconnect_error:
    'Sorry for the inconvenience. We encountered an issue while disconnecting your social account. Please try again later. If the problem persists, contact support.',
  social_fetch_error:
    'Sorry for the inconvenience. We encountered an issue while loading your social accounts. Please try again later. If the problem persists, contact support.',

  // Onboarding errors
  onboarding_posts_error:
    'Sorry for the inconvenience.An error occurred while generating your posts. Please try again later. If the problem persists, contact support.',
  post_feedback_error:
    'Sorry for the inconvenience. We encountered an issue while sending your feedback. Please try again later. If the problem persists, contact support.',
  server_error:
    'Sorry for the inconvenience. A critical error occurred. Please try again later. If the problem persists, contact support.',
  dashboard_posts_error:
    'Sorry for the inconvenience. An error occurred while loading your posts. Please try again later. If the problem persists, contact support.',
};

/**
 * Get error message for a specific error type
 * @param {string} errorType - The error type key
 * @returns {string} - The error message for that type
 */
export const getErrorModalMessage = (errorType) => {
  const message = errorMessages[errorType];

  if (!message) {
    console.warn(`Error message for type "${errorType}" not found. Using general_error message.`);
    return errorMessages.general_error;
  }

  return message;
};

export default { errorMessages, getErrorModalMessage };
